export default "__VITE_ASSET__BqlUhqbz__"